let ContactForm = {
    init() {
        document.querySelectorAll('.wpcf7-form input,.wpcf7-form textarea,#user_login,#user_pass ')?.forEach((elem) => {
            elem.addEventListener('focus', (event) => {
                this.focus(event);
            });
            elem.addEventListener('blur', (event) => {
                this.blur(event);
            });
        });
    },
    focus(event) {
        if (event.currentTarget.id === "user_login" || event.currentTarget.id === "user_pass") {
            event.currentTarget?.parentElement?.querySelector('label')?.classList.add('filled');
        } else {
            event.currentTarget?.parentElement?.parentElement?.querySelector('.label')?.classList.add('filled');
        }
    },

    blur(event) {
        if (event.currentTarget.value === "") {
            if (event.currentTarget.id === "user_login" || event.currentTarget.id === "user_pass") {
                event.currentTarget?.parentElement?.querySelector('label')?.classList.remove('filled');
            } else {
                event.currentTarget?.parentElement?.parentElement?.querySelector('.label')?.classList.remove('filled');

            }
        }
    },
}
export default ContactForm;
